export default "__VITE_ASSET__BQZnnoqi__"